module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-bar"
  }, [_vm._l((_vm.columns), function(col) {
    return _c('span', {
      key: col.name,
      attrs: {
        "data-column": col.name
      }
    }, [_c('GenericInput', {
      attrs: {
        "col": col,
        "row": _vm.row,
        "onChange": _vm.updateRow.bind(null, _vm.row.id, col.name)
      }
    })], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "destroy",
    on: {
      "click": function($event) {
        return _vm.destroy()
      }
    }
  }, [_c('Delete', {
    staticClass: "button"
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-306f4abb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditBar.vue
// module id = 671
// module chunks = 2